module.exports = __webpack_public_path__ + "static/media/signal-stream.bace3c85.svg";